
require(["readium_cfi_js/cfi_API", "readium_shared_js/globalsSetup", "readium_js_viewer/ReadiumViewerLite"]);
